/* eslint-disable max-len */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
import React, { useState } from 'react';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { Navigation } from './components/Nav';
import './Header.css';

function Header(props) {
  const {
    headerTheme,
    secondaryTheme,
    footerTheme,
    headerTextColor,
    footerTextColor,
    title,
    logo,
    origin,
    buttonTextColor,
    partner,
    url,
    bannerColor,
  } = props;
  const [displayState, setDisplayState] = useState('flex');
  const [appBarMargin, setAppBarMargin] = useState('50px');
  const removeTopbar = () => {
    setDisplayState('none');
    setAppBarMargin('0px');
  };

  return (
    <>
      <div className="topbar" style={{ display: `${displayState}`, backgroundColor: bannerColor }}>
        <div style={{ minWidth: '90%' }}>
          PURCHASE WITH CONFIDENCE: AMERICAN-MADE WORKPLACE SEATING | 15 YEAR WARRANTY
        </div>
        <svg className="svg-icon" aria-hidden="true" role="img" focusable="false" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: 'pointer' }} onClick={removeTopbar}>
          <path d="M12.2218 13.6066L20 21.3848L21.4142 19.9706L13.636 12.1924L21.3848 4.44366L19.9706 3.02945L12.2218 10.7782L4.44365 3L3.02944 4.41421L10.8076 12.1924L3 20L4.41421 21.4142L12.2218 13.6066Z" fill="currentColor" />
        </svg>
      </div>
      <AppBar
        position="static"
        color="primary"
        elevation={2}
        sx={{
          alignItems: 'center',
          marginTop: `${appBarMargin}`,
        }}
      >
        <Toolbar sx={{
          flexWrap: 'wrap',
          '@media (max-width: 912px)': {
            flexDirection: 'column',
            justifyContent: 'center',
          },
          flexDirection: 'row',
          justifyContent: 'space-between',
          paddingBottom: 2,
          paddingTop: 2,
        }}
        >

          <Stack
            direction="row"
            sx={{
              flexGrow: 1,
              '@media (min-width: 912px)': {
                marginLeft: 15,
              },
              alignItems: 'center',
            }}
          >
            {/* <Typography variant="h3" align="center" color={headerTextColor} sx={{ flexGrow: 1 }}>
            {title}'s Seating Portal
          </Typography> */}
            <a href={origin} aria-label="Go to homepage">
              <img
                src={logo}
                alt="Company Logo"
                style={{
                  maxHeight: '55px',
                  maxWidth: '250px',
                  '@media (min-width: 912px)': {
                    marginLeft: 15,
                  },
                }}
              />
            </a>
          </Stack>
          <Stack
            sx={{
              flexGrow: 1,
              '@media (min-width: 912px)': {
                marginLeft: 15,
                flexDirection: 'row',
              },
              alignItems: 'center',
            }}
          >
            <Navigation headerTextColor={headerTextColor} partner={partner} url={url} />
            <Button
              href={origin}
              color="secondary"
              variant="contained"
              sx={{
                my: 0.5,
                mx: 1,
                py: 1,
                color: buttonTextColor,
                '@media (min-width: 912px)': {
                  marginLeft: 0,
                },
              }}
            >
              Return to Main Site
            </Button>
          </Stack>
        </Toolbar>
      </AppBar>
    </>
  );
}

export default Header;
